module.exports = __webpack_public_path__ + "media/bootstrap-icons/menu-button-fill-2f80742c.svg";